  // Video slider js start
  let videoSlider = document.querySelector(".custom-videos__sec .swiper-container");
  if (videoSlider) {
    let videoSwiper = new Swiper(videoSlider, {
      slidesPerView: 1.32,
      loop: false,
      loopAdditionalSlides: 30,
      spaceBetween: 16,
      breakpoints: {
        568: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 22,
        },
        1199: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
      },
    });
  }
  // Video slider js end

  // Custom Step slider js start
  let stepSlider = document.querySelector(".custom-step .swiper-container");
  if (stepSlider) {
    let stepSwiper = new Swiper(stepSlider, {
      slidesPerView: 1.32,
      loop: false,
      loopAdditionalSlides: 30,
      spaceBetween: 16.2,
      breakpoints: {
        568: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        1199: {
          slidesPerView: 3,
          spaceBetween: 87,
        },
      },
    });
  }
  // Custom Step slider js end

  // Custom column section js start
  let bodyColumnSlider = document.querySelector(".body-column__sec .swiper-container");
  if (bodyColumnSlider) {
    let bodySwiper = new Swiper(bodyColumnSlider, {
      slidesPerView: 1.33,
      loop: false,
      loopAdditionalSlides: 30,
      spaceBetween: 16,
      breakpoints: {
        568: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 22,
        },
        1199: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
      },
    });
  }
  // Custom column section js end

  // Testimonial slider js start
  let testimonialSlider = document.querySelector(".testimonial_slider .swiper-container");
  if (testimonialSlider) {
    let testimonialSwiper = new Swiper(testimonialSlider, {
      slidesPerView: 1,
      loop: false,
      loopAdditionalSlides: 30,
      spaceBetween: 0,
      autoHeight: true,
      pagination: {
        el: ".slider__pagination",
        clickable: true,
      },
    });
  }
  // Testimonial slider js end

  // Custom icon with text slider js start
  let iconWithTextSlider = document.querySelector(".custom-icon__withtext .swiper-container");
  if (iconWithTextSlider) {
    let iconWithTextSwiper = new Swiper(iconWithTextSlider, {
      slidesPerView: 1.4,
      loop: false,
      loopAdditionalSlides: 30,
      spaceBetween: 16,
      breakpoints: {
        568: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 22,
        },
        1199: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    });
  }
  // Custom icon with text slider js end

// faq accordian sec start here
const headers = document.querySelectorAll(".accordion-header");
headers.forEach((header) => {
  header.addEventListener("click", () => {
    const isActive = header.classList.contains("active");
    headers.forEach((h) => {
      h.classList.remove("active");
      h.nextElementSibling.style.display = "none";
    });
    if (!isActive) {
      header.classList.add("active");
      header.nextElementSibling.style.display = "block";
    }
  });
});
// faq accordian sec End here

// Tooltip js start here
document.addEventListener("DOMContentLoaded", function () {
  const wrappers = document.querySelectorAll(".sibling-product__wrapper");
  wrappers.forEach(function (wrapper) {
    const tooltipTrigger = wrapper.querySelector(".tooltip-txt");
    const closeBtn = wrapper.querySelector(".popup__toltip-close");
    if (tooltipTrigger && closeBtn) {
      tooltipTrigger.addEventListener("click", function (e) {
        e.stopPropagation();
        
        wrappers.forEach((w) => w.classList.remove("active-tooltip"));
        wrapper.classList.add("active-tooltip");
      });
      closeBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        
        wrapper.classList.remove("active-tooltip");
      });
    }
  });
  document.addEventListener("click", function (e) {
    
    wrappers.forEach(function (wrapper) {
      if (!wrapper.contains(e.target)) {
        wrapper.classList.remove("active-tooltip"); 
      }
    });
  });
});
// Tooltip js End here

